export enum Integration {
    MAERSK = 'maersk',
    ONE_PORT = 'onePort',
    CLOUD_FLEET_MANAGER = 'cloudFleetManager',
    BASS_NET = 'bassNet',
}
